import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MainLayoutStore } from '../services/main.layout.store';
import { TranslatePipe } from '../../shared/pipes/translate.pipe';
import { AuthStore } from '../../core/auth/services/auth.store';
import { ActivatedRoute, NavigationEnd, NavigationStart, Router } from '@angular/router';
import { fromEvent, Subject } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { TimeagoIntl } from 'ngx-timeago';
import { strings as frenchStrings } from 'ngx-timeago/language-strings/fr';
import { TranslateService } from 'src/app/shared/services/translate.service';
import { mainMenu } from 'src/app/shared/helpers/animations';
import { MainStore } from './services/main.store';
import { APP_CONFIG } from '../../app.config';
import { ModalBasicComponent } from '../../shared/components/modal-basic/modal-basic.component';

declare var require: any;

@Component({
  selector: 'app-main-screen',
  templateUrl: './main-screen.component.html',
  styleUrls: ['./main-screen.component.css'],
  providers: [MainStore],
  animations: [mainMenu],
})
export class MainScreenComponent implements OnInit, AfterViewInit, OnDestroy {
  public env = { ...APP_CONFIG };
  onRouterNavigation = false;

  @ViewChild('ngbPopover') popover: NgbPopover;
  @ViewChild('modalAbout') modalAbout: ModalBasicComponent;
  @ViewChild('modalPreviewUpgrade') modalPreviewUpgrade: ModalBasicComponent;
  @ViewChild('upgradePreview') upgradePreview: ElementRef;
  currentYear: any;
  private ngUnsubscribe$: Subject<undefined> = new Subject();
  webVersion = require('../../../../package.json').version;
  currentServerVersion: string;
  live = true;

  constructor(
    public layoutStore: MainLayoutStore,
    public authStore: AuthStore,
    private router: Router,
    private translate: TranslatePipe,
    public translator: TranslateService,
    private route: ActivatedRoute,
    private intl: TimeagoIntl,
    public store: MainStore
  ) {
    this.layoutStore.windowWidth = window.innerWidth;
    this.store.init();
    this.intl.strings = frenchStrings;

    this.intl.changes.next();
  }

  ngOnInit(): void {
    this.currentYear = new Date().getFullYear();

    this.router.events
      .pipe(
        tap((event) => {
          if (event instanceof NavigationEnd) {
            this.onRouterNavigation = false;
            window.document.getElementsByTagName('body').item(0).classList.remove('route-loading');
          } else if (event instanceof NavigationStart) {
            this.onRouterNavigation = true;
            document.getElementsByTagName('body')[0].classList.add('route-loading');
          }
        })
      )
      .subscribe();
  }

  ngAfterViewInit(): void {
    this.setupNotificationClickListener();
  }

  ngOnDestroy(): void {
    this.disconnect();
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }

  onResize(event) {
    this.layoutStore.windowWidth = event.target.innerWidth;
  }

  show_end_screen() {
    this.router.navigate(['./']);
  }

  toggleOpened(cb?: any) {
    if (this.layoutStore.state.layoutAttr.verticalNavType === 'expanded') {
      this.layoutStore.verticalNavType = 'compact';
      this.layoutStore.toggleMenuTooltip = this.translate.transform('SHOWMENU');
      this.layoutStore.closeSubMenus();
    } else {
      this.layoutStore.verticalNavType = 'expanded';
      this.layoutStore.toggleMenuTooltip = this.translate.transform('HIDEMENU');
      if (cb) {
        cb();
      }
    }
  }

  toggleSubmenu($e, asideItem) {
    const el = $e.target as Element;
    if (this.layoutStore.state.layoutAttr.verticalNavType === 'compact') {
      this.toggleOpened(() => {
        el.closest('.pcoded-hasmenu').classList.add('pcoded-trigger');
      });
    }
    if (
      el.closest('.pcoded-hasmenu').classList.contains('pcoded-trigger') &&
      asideItem.autoSelect === true &&
      asideItem.children[0] &&
      (el.classList.contains('auto-select') ||
        el.classList.contains('pcoded-hasmenu') ||
        el.parentElement.classList.contains('auto-select') ||
        el.parentElement.parentElement.classList.contains('auto-select'))
    ) {
      this.router.navigate(['/', asideItem.state, asideItem.children[0].state]);
    }
  }

  onClickedOutside(e: Event) {
    if (
      this.layoutStore.state.layoutAttr.windowWidth < 768 &&
      this.layoutStore.state.layoutAttr.verticalNavType !== 'offcanvas'
    ) {
      this.layoutStore.verticalNavType = 'offcanvas';
    }
  }

  disconnect() {
    this.authStore.logout();
    this.router.navigate(['./login']);
  }

  hideOnDashboard() {
    return true || !this.router.url.toLocaleLowerCase().includes('dashboard');
  }

  onActivate(event) {
    window.scroll(0, 0);
  }

  onDeactivate(event) {
    window.scroll(0, 0);
  }

  private setupNotificationClickListener() {
    const clickEvent = fromEvent(document, 'click');
    clickEvent
      .pipe(
        tap((event) => {
          const headers = document.querySelectorAll('.header-notification');
          const el = event.target as Element;
          let isClickInside = false;
          headers.forEach((header) => {
            if (!isClickInside) {
              isClickInside = header.contains(el);
            }
          });
          if (el.closest('.navbar-dropdow-item') !== null) {
            document.querySelectorAll('.show-notification.open').forEach(($el) => {
              $el.classList.remove('open');
            });
          }
          if (el.querySelector('.show-notification.open') != null) {
            el.querySelector('.show-notification.open').classList.remove('open');
            return;
          }
          if (!isClickInside) {
            document.querySelectorAll('.show-notification.open').forEach(($el) => {
              $el.classList.remove('open');
            });
          }
          if (!el.classList.contains('header-notification')) {
            return;
          }
          if (document.querySelectorAll('.show-notification.open').length !== 0) {
            document.querySelectorAll('.show-notification.open').forEach(($el) => {
              $el.classList.remove('open');
            });
          }

          if (el.querySelector('.show-notification').classList.contains('open')) {
            el.querySelector('.show-notification').classList.remove('open');
          } else {
            document.querySelectorAll('.show-notification.open').forEach(($el) => {
              $el.classList.remove('open');
            });
            el.querySelector('.show-notification').classList.add('open');
          }
          event.preventDefault();
        }),
        takeUntil(this.ngUnsubscribe$)
      )
      .subscribe();
  }

  showAboutModal() {
    this.store.getServerVersion().subscribe((res) => {
      this.currentServerVersion = res;
    });
    this.modalAbout.show();
  }

  resolveMenuClicked(menuState: string) {
    const isOfficeManager = !!this.authStore.state.accountInfo.roleKeys.find((key) => key.toUpperCase() === 'OM');
    if (this.authStore.state.accountInfo.role.toUpperCase() === 'SHAREHOLDER' || isOfficeManager) {
      let actionType = null;
      if (menuState === 'dashboard') {
        actionType = 'DASHBOARD_ACCESS';
      }
      if (menuState === 'employees') {
        actionType = 'EMPLOYEES_LIST_ACCESS';
      }
      if (menuState === 'expenses') {
        actionType = 'EXPENSES_ACCESS';
      }
      if (menuState === 'sales') {
        actionType = 'SALES_ACCESS';
      }
      if (actionType !== null) {
        this.authStore.logAction(actionType);
      }
    }
  }
}
